// Redirect trailing "?" with no actual query params (e.g. /collections/rtw-new?)
if (window.location.href.endsWith('?')) {
  window.history.replaceState({}, document.title, window.location.pathname);
}

// Store URL parameters before they might be cleared
const initialUrlParams = new URLSearchParams(window.location.search);

if (
  document.referrer &&
  !document.referrer.includes(window.location.hostname)
) {
  // Only clear URL if there are no filter/sort parameters to preserve
  const hasFilterParams =
    initialUrlParams.has('color') ||
    initialUrlParams.has('sort') ||
    initialUrlParams.has('collections') ||
    initialUrlParams.has('size') ||
    initialUrlParams.has('dress_type') ||
    initialUrlParams.has('aesthetic') ||
    initialUrlParams.has('details') ||
    initialUrlParams.has('silhouette') ||
    initialUrlParams.has('fabric') ||
    initialUrlParams.has('length') ||
    initialUrlParams.has('product_type') ||
    initialUrlParams.has('in_stock') ||
    initialUrlParams.has('occasion') ||
    initialUrlParams.has('price_min') ||
    initialUrlParams.has('price_max') ||
    initialUrlParams.has('utm_source') ||
    initialUrlParams.has('utm_medium') ||
    initialUrlParams.has('utm_campaign') ||
    initialUrlParams.has('utm_content') ||
    initialUrlParams.has('utm_term') ||
    initialUrlParams.has('_kx') ||
    Array.from(initialUrlParams.keys()).some((key) =>
      key.startsWith('filter.')
    );

  if (window.location.search && !hasFilterParams) {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
}
(() => {
  const chip_svg = `<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 37 40"><path d="M21.3 23l11-11c.8-.8.8-2 0-2.8-.8-.8-2-.8-2.8 0l-11 11-11-11c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l11 11-11 11c-.8.8-.8 2 0 2.8.4.4.9.6 1.4.6s1-.2 1.4-.6l11-11 11 11c.4.4.9.6 1.4.6s1-.2 1.4-.6c.8-.8.8-2 0-2.8l-11-11z"/></svg>`;

  let color_dictionary = {};
  async function loadColorDictionary() {
    try {
      const colorJsonUrl = document.getElementById('color-json-url')?.value;
      if (!colorJsonUrl) return;
      const response = await fetch(colorJsonUrl);
      if (!response.ok)
        throw new Error(
          `Erreur lors du chargement du dictionnaire: ${response.status}`
        );
      const data = await response.json();
      color_dictionary = data;
      window.color_dictionary = data;
    } catch (error) {
      console.error(
        'Erreur lors du chargement du dictionnaire de couleurs:',
        error
      );
    }
  }
  let all_images, inventory_data, collection_data;

  // Initialization
  const current_collection = $('input#hidden-current-collection').val();
  const current_collection_id = $('input#hidden-current-collection-id').val();
  Promise.all([
    fetch(`/collections/${current_collection}?view=images`).then((resp) =>
      resp.json()
    ),
    fetch(
      `https://api.ecom.amsale.com/api/inventory/${current_collection_id}/products`
    ).then((resp) => resp.json()),
    fetch(`/collections/${current_collection}?view=filtering`).then((resp) =>
      resp.json()
    ),
  ])
    .then((values) => {
      all_images = values[0];
      if (values[1].products !== null) {
        collection_data = values[1];
        console.log('Inventory data loaded successfully:', inventory_data);
      } else {
        // If Inventory is NULL because of a Shopify/API issue
        // We hide the Stocks checkboxes
        $('.sizes-wrapper').hide().next('hr').hide();
      }
      collection_data = values[2];
      console.log('Loaded collection data:', collection_data);
      console.log('Loaded inventory data:', inventory_data);
      console.log('Loaded all images data:', all_images);
      // Stupid non-practical and tedious logic
      // Check if the URL has a pre-filter value in the pathname

    })
    .catch((error) => {
      console.error(
        'Erreur lors du chargement des données de la collection:',
        error
      );
    });
  function formatChipLabel(label) {
    return label
      .split(/[-_]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  function getSwatchColorsFromVariants(product) {
    const swatches = new Set();
    if (!product || !Array.isArray(product.variants)) return [];
    if (Array.isArray(product.options)) {
      const colorOption = product.options.find(
        (opt) => opt.name.toLowerCase() === 'color'
      );
      if (colorOption)
        colorOption.values.forEach((val) => swatches.add(val.toLowerCase()));
    }
    if (Array.isArray(product.options_with_values)) {
      const colorOption = product.options_with_values.find(
        (opt) => opt.name.toLowerCase() === 'color'
      );
      if (colorOption)
        colorOption.values.forEach((val) => swatches.add(val.toLowerCase()));
    }
    return Array.from(swatches);
  }

  function getMatchingSwatches(baseColor, colorDict, productSwatches) {
    if (
      !baseColor ||
      typeof baseColor !== 'string' ||
      !Array.isArray(productSwatches) ||
      productSwatches.length === 0
    )
      return [];
    const baseLower = baseColor.toLowerCase();
    const results = { exact: [], baseMatch: [], partial: [], related: [] };
    const normalizedSwatches = productSwatches.map((s) => s.toLowerCase());

    if (normalizedSwatches.includes(baseLower)) results.exact.push(baseLower);

    for (const swatch of normalizedSwatches) {
      if (results.exact.includes(swatch)) continue;
      if (swatch.includes(baseLower) || baseLower.includes(swatch))
        results.partial.push(swatch);
    }

    if (colorDict) {
      for (const [colorKey, colorEntry] of Object.entries(colorDict)) {
        const swatchLower = colorKey.toLowerCase();
        if (!normalizedSwatches.includes(swatchLower)) continue;
        if (
          results.exact.includes(swatchLower) ||
          results.partial.includes(swatchLower)
        )
          continue;
        const baseArray = Array.isArray(colorEntry?.base)
          ? colorEntry.base
          : (colorEntry?.base || '').split(',').map((x) => x.trim());
        const baseParts = baseArray.map((x) => x.toLowerCase());
        if (baseParts.includes(baseLower)) results.baseMatch.push(swatchLower);
      }
      const baseColorEntry = colorDict[baseLower];
      if (baseColorEntry && baseColorEntry.base) {
        const baseDefinition = Array.isArray(baseColorEntry.base)
          ? baseColorEntry.base
          : baseColorEntry.base.split(',').map((x) => x.trim());
        for (const [colorKey, colorEntry] of Object.entries(colorDict)) {
          const swatchLower = colorKey.toLowerCase();
          if (!normalizedSwatches.includes(swatchLower)) continue;
          if (
            results.exact.includes(swatchLower) ||
            results.partial.includes(swatchLower) ||
            results.baseMatch.includes(swatchLower)
          )
            continue;
          const swatchBases = Array.isArray(colorEntry?.base)
            ? colorEntry.base
            : (colorEntry?.base || '').split(',').map((x) => x.trim());
          if (
            swatchBases.some((base) =>
              baseDefinition.some((b) => b.toLowerCase() === base.toLowerCase())
            )
          )
            results.related.push(swatchLower);
        }
      }
    }
    return [
      ...results.exact,
      ...results.baseMatch,
      ...results.partial,
      ...results.related,
    ];
  }

  function buildCardColorPalette(product) {
    let cardPaletteHtml = '';
    let swatch_count = 0;
    let product_swatches = [];

    if (product.options) {
      const colorOption = product.options.find(
        (option) => option.name === 'Color' || option.name === 'color'
      );
      if (colorOption && colorOption.values) {
        swatch_count = parseInt(colorOption.values.length);
        product_swatches = colorOption.values;
      }
    }

    const hidden_asset_path = $('input#hidden-asset-url').val();
    if (!hidden_asset_path) {
      console.warn("Chemin d'asset manquant pour les nuanciers de couleurs");
      return '';
    }

    const asset_url = hidden_asset_path.substring(
      0,
      hidden_asset_path.indexOf('black.jpg')
    );

    if (swatch_count > 1) {
      cardPaletteHtml += `<div class='card-color-palette'>`;
      for (let index = 0; index < swatch_count; index++) {
        if (index <= 4) {
          const asset_name = product_swatches[index];
          if (!asset_name) continue;

          // ← NORMALISATION : remplace espaces par tirets et met en minuscules
          const normalized_asset_name = asset_name
            .replace(/\s+/g, '-') // Remplace tous les espaces par des tirets
            .toLowerCase(); // Met en minuscules

          cardPaletteHtml += `
        <img
          class='card-color'
          src='${asset_url + normalized_asset_name}.jpg'
          alt='Swatch of color ${asset_name}'
          loading='lazy'
          width='12'
          height='12'
          onerror="this.style.display='none'" />
      `;
        } else {
          break;
        }
      }
      if (swatch_count > 5) {
        cardPaletteHtml += `<div class='more-colors-label'>+ ${
          swatch_count - 5
        }</div>`;
      }
      cardPaletteHtml += `</div>`;
    }
    return cardPaletteHtml;
  }

  function gidToShopifyUrl(gid) {
    const id = gid.split('/').pop();
    return id
      ? `https://cdn.shopify.com/s/files/1/0032/0562/7968/files/${id}.jpg`
      : null;
  }

  function getImageTagForProduct(handle) {
    if (
      window.collectionMetafields &&
      Array.isArray(window.collectionMetafields.metafields)
    ) {
      const productMeta = window.collectionMetafields.metafields.find(
        (p) => p.handle === handle
      );
      return productMeta ? productMeta.image_tag : null;
    }
    return null;
  }

  // --- UI ---
  const UI = {
    elements: {
      formSideBar: null,
      formSortBy: null,
      grid: null,
      count: null,
      chips: null,
      clear: null,
    },

    initialize() {
      this.elements = {
        formSideBar: $('#CollectionFiltersSideBar'),
        formSortBy: $('#CollectionFiltersSortBy'),
        grid: $('ul.product-cards-container'),
        count: $('.filters-toolbar__product-count'),
        chips: $('#filter-chips-container'),
        clear: $('a.clear-filters'),
      };
      if (this.elements.grid.length) {
        this.elements.grid.removeAttr('style');
        Utils.hideLoading(this.elements.grid);
      }
    },

    initChips() {
      const $chips = this.elements.chips;
      if (!$chips || !$chips.length) return;
      $chips.empty();
      // ...dans UI.initChips()...
      const queryString = Utils.serializeAllForms();
      const params = new URLSearchParams(queryString);
      const chipDisplayMapping = {
        cocktail: 'Cocktail Dress',
        'evening-mob': 'Mother of the Bride/Groom',
        mini: 'Mini Dress',
        'long-sleeve': 'Long Sleeve',
        'nouvelle-bridal': 'Nouvelle Amsale',
        slits: 'Slits in Skirt',
        'day-dress': 'Daytime Dress',
        'amsale-bridal': 'AMSALE',
        'rts-bm': 'Ready to Ship',
        'mto-bm': 'Made to Order',
      };

      params.forEach((value, key) => {
        if (
          [
            'current-collection',
            'current-collection-id',
            'min_price',
            'max_price',
            'sort',
          ].includes(key)
        )
          return;
        value.split(',').forEach((val) => {
          let type = key;
          let label = val;
          let $input;

          if (type === 'collections') {
            $input = this.elements.formSideBar.find(
              `input[data-type="collections"][value="${val}"]`
            );
          } else {
            $input = this.elements.formSideBar.find(
              `[name="${key}"][value="${val}"]`
            );
          }

          if ($input.length) {
            if ($input.data('label')) {
              label = $input.data('label');
            }

            // 3) else try the <label for="…"> text
            else {
              const id = $input.attr('id');
              const $lbl = this.elements.formSideBar.find(`label[for="${id}"]`);
              if ($lbl.length) {
                label = $lbl.text().trim();
              }
            }
          }
          if (!label || label === val) {
            label = chipDisplayMapping[val] || formatChipLabel(val);
          }

          $chips.append(`
        <div class="filter-chip" data-type="${type}" data-value="${val}">
          ${label}
          <button class="remove-filter-btn" data-type="${type}" data-value="${val}">
            ${chip_svg}
          </button>
        </div>
      `);
        });
      });

      const min = params.get('min_price');
      const max = params.get('max_price');
      if (min || max) {
        const rangeMin = UI.elements.formSideBar.find('.range-min')[0];
        const rangeMax = UI.elements.formSideBar.find('.range-max')[0];
        const minDisplay = min || (rangeMin ? rangeMin.min : '0');
        const maxDisplay = max || (rangeMax ? rangeMax.max : '9999');
        let priceLabel = '';
        if (min && max && min === max) {
          priceLabel = `$${min}`;
        } else {
          priceLabel = `$${minDisplay} - $${maxDisplay}`;
        }
        $chips.append(`
      <div class="filter-chip" data-type="price">
        ${priceLabel}
        <button class="remove-filter-btn" data-type="price">${chip_svg}</button>
      </div>
    `);
      }
      const sort = params.get('sort');
      if (sort) {
        let sortLabel = '';
        if (sort === 'price_low_high') sortLabel = 'Price: Low to High';
        else if (sort === 'price_high_low') sortLabel = 'Price: High to Low';
        else sortLabel = 'Sort: ' + sort;
        $chips.append(`
     <div class="filter-chip" data-type="sort">
       ${sortLabel}
       <button class="remove-filter-btn" data-type="sort">${chip_svg}</button>
     </div>
   `);
      }
      if ($chips.find('.filter-chip').length > 0) {
        $chips.prepend(`
    <a href="#" class="clear-filters" aria-label="Clear all filters">Clear all</a>
  `);
      }

      this.elements.clear = this.elements.clear || $('a.clear-filters');
      this.elements.clear.toggleClass('show', params.toString() !== '');
    },

    renderProducts(products, totalCount) {
      console.log('Rendering products:', products, 'Total count:', totalCount);
      const $grid = this.elements.grid;
      const $count = this.elements.count;
      if (!$grid.length) return;
      $grid.empty();
      if (!products || !products.length) {
        $grid.html('<li class="no-results">No Results Found</li>');
        $count.text('0 produit');
        return;
      }
      products.forEach((product) => {
        const mainImage =
          product.images && product.images.length > 0
            ? product.images[0].src
            : '';
        const price =
          product.price ||
          (product.variants && product.variants[0]
            ? product.variants[0].price
            : null);
        const formattedPrice = price ? `$${Math.round(price)}` : '';
        const imgId = `img-${product.handle}`;
        let imageTag = product.metafields?.amsale?.image_tag?.value;
        if (!imageTag && window.collectionMetafields) {
          imageTag = getImageTagForProduct(product.handle);
        }
        let colorPalette = '';
        if (
          product.options &&
          product.options.some((opt) => opt.name.toLowerCase() === 'color')
        ) {
          colorPalette = buildCardColorPalette(product);
        }
        $grid.append(`
      <li class="product-card-list-item grid__item medium-up--one-third" 
          data-product-handle="${product.handle}" 
          data-product-collections="${(product.collections || []).join(',')}"
          data-product-id="${product.id || ''}">
        <div class="custom__product-card">
          <a href="/products/${product.handle}" data-product-handle="${
          product.handle
        }" >
            <div style="position: relative;">
              <div class="hover-reveal-effect">
                <img id="${imgId}" class="grid-view-item__image lazyload productFullImg" 
                    src="${mainImage}" 
                    alt="${product.title}" 
                    loading="lazy"/>
                ${
                  product.images && product.images.length > 1
                    ? `<img class="grid-view-item__image lazyload productFullImg hidden-reveal-image" 
                        src="${product.images[1].src}" 
                        alt="${product.title}" 
                        loading="lazy" 
                        tabindex="-1"/>`
                    : ''
                }
                ${
                  imageTag
                    ? `
              <span class="image-tag">${imageTag || ''}</span>
            `
                    : ''
                }
            </div>
            </div>
            <div class="product-card__title_wrapper">
              <div class="card-flex-wrapper">
                <h4>${product.title}</h4>
                ${colorPalette}
              </div>
              <div class="card-flex-wrapper price-wrapper">
                <h5>${formattedPrice}</h5>
              </div>
            </div>
          </a>
        </div>
      </li>
    `);
      });

      const productText = totalCount === 1 ? 'produit' : 'produits';
      $count.text(`${totalCount} ${productText}`);
      $('.filters-toolbar__product-count').not($count).hide();
      this.loadVariantImages(products);
      // Load compare_at_price values and update card UI (struck price + sale price)
      this.loadComparePrices(products);
    },

    loadVariantImages(products) {
      const urlParams = new URLSearchParams(window.location.search);
      const colorParam = urlParams.get('color');
      let filteredColors = [];
      if (colorParam) {
        filteredColors = colorParam
          .split(',')
          .map((c) => c.trim().toLowerCase());
      }
      const productCards = Array.from($('.product-card-list-item'));
      const batchSize = 5;

      const processBatch = async (startIndex) => {
        const batch = productCards.slice(startIndex, startIndex + batchSize);
        await Promise.all(
          batch.map(async (card) => {
            const $card = $(card);
            const handle = $card.data('product-handle');
            if (!handle) return;
            const $image = $card.find('.productFullImg').first();
            if (!$image.length) return;
            const imgId = $image.attr('id');
            if (!imgId) return;
            try {
              const productData = products.find((p) => p.handle === handle);
              if (!productData) return;
              const productSwatches = getSwatchColorsFromVariants(
                productData
              ).map((s) => s.toLowerCase());
              let colorToUse = '';
              const lastClickedColor = localStorage.getItem('lastClickedColor');
              if (
                filteredColors.length > 0 &&
                lastClickedColor &&
                filteredColors.includes(lastClickedColor)
              ) {
                if (productSwatches.includes(lastClickedColor)) {
                  colorToUse = lastClickedColor;
                } else {
                  const match = getMatchingSwatches(
                    lastClickedColor,
                    color_dictionary,
                    productSwatches
                  )[0];
                  if (match) colorToUse = match;
                }
              }
              if (!colorToUse && filteredColors.length > 0) {
                for (let i = filteredColors.length - 1; i >= 0; i--) {
                  const filterColor = filteredColors[i];
                  if (productSwatches.includes(filterColor)) {
                    colorToUse = filterColor;
                    break;
                  }
                  const match = getMatchingSwatches(
                    filterColor,
                    color_dictionary,
                    productSwatches
                  )[0];
                  if (match) {
                    colorToUse = match;
                    break;
                  }
                }
                if (!colorToUse) {
                  colorToUse = productSwatches[0] || '';
                }
              } else if (!colorToUse) {
                const lastColor = localStorage.getItem('lastSelectedColor');
                if (lastColor && productSwatches.includes(lastColor)) {
                  colorToUse = lastColor;
                } else {
                  colorToUse = productSwatches[0] || '';
                }
              }
              if (colorToUse) {
                await injectSwatchImage(productData, colorToUse, imgId);
              }
            } catch (err) {
              console.error(
                `Erreur lors du chargement de l'image pour ${handle}:`,
                err
              );
            }
          })
        );
        if (startIndex + batchSize < productCards.length) {
          setTimeout(() => processBatch(startIndex + batchSize), 100);
        }
      };
      if (productCards.length > 0) processBatch(0);
    },

    // Load compare_at_price for products and update card prices when applicable.
    loadComparePrices(products) {
      const productCards = Array.from($('.product-card-list-item'));
      const batchSize = 5;

      const processBatch = async (startIndex) => {
        const batch = productCards.slice(startIndex, startIndex + batchSize);
        await Promise.all(
          batch.map(async (card) => {
            const $card = $(card);
            const handle = $card.data('product-handle');
            if (!handle) return;
            const $priceWrapper = $card.find('.price-wrapper h5');
            if (!$priceWrapper.length) return;
            try {
              const res = await fetch(`/products/${handle}.js`, {
                cache: 'no-store',
              });
              if (!res.ok) throw new Error('HTTP ' + res.status);
              const product = await res.json();
              console.log(
                'Fetching product data for compare_at_price:',
                handle,
                product
              );

              const variants = Array.isArray(product.variants)
                ? product.variants
                : [];
              if (!variants.length) return;
              // Build arrays of valid positive prices (exclude 0 and NaN)
              const pricesFiltered = variants
                .map((v) => Number(v.price))
                .filter((p) => p > 0 && !isNaN(p));
              const comparesFiltered = variants
                .map((v) =>
                  v.compare_at_price ? Number(v.compare_at_price) : null
                )
                .filter((c) => c > 0 && !isNaN(c));

              const minPrice = pricesFiltered.length
                ? Math.min(...pricesFiltered)
                : null;
              const minCompare = comparesFiltered.length
                ? Math.min(...comparesFiltered)
                : null;

              // Only display prices when we have a positive, non-zero price.
              if (minPrice && minCompare && minCompare > minPrice) {
                $priceWrapper.html(
                  `<span class="compare-price" style="text-decoration:line-through;color:#777;margin-right:6px">$${
                    Math.round(minCompare) / 100
                  }</span>` +
                    `<span class="sale-price" style="color:#01372c">$${
                      Math.round(minPrice) / 100
                    }</span>`
                );
              } else if (minPrice) {
                $priceWrapper.text(`$${Math.round(minPrice) / 100}`);
              } else {
                // No valid positive price found -> hide price (no $0)
                $priceWrapper.text('');
              }
            } catch (err) {
              // silently ignore per-product failures
              // console.error('compare price load failed', handle, err);
            }
          })
        );
        if (startIndex + batchSize < productCards.length) {
          setTimeout(() => processBatch(startIndex + batchSize), 100);
        }
      };
      if (productCards.length > 0) processBatch(0);
    },
  };

  async function injectSwatchImage(product, baseColor, imgElementId) {
    const imgEl = document.getElementById(imgElementId);
    if (!imgEl) return;
    const normalizedBase = baseColor;
    const productSwatches =
      Array.isArray(product.swatches) && product.swatches.length > 0
        ? product.swatches.map((s) => s.toLowerCase())
        : getSwatchColorsFromVariants(product).map((s) => s.toLowerCase());

    const colorDictionary = color_dictionary || {};
    const exactMatch = productSwatches.includes(normalizedBase);
    let tryList = exactMatch
      ? [normalizedBase]
      : getMatchingSwatches(baseColor, colorDictionary, productSwatches);

    if (tryList.length === 0) {
      return;
    }

    let matchedColor = null;
    for (const colorToTry of tryList) {
      const lowerColor = colorToTry.toLowerCase();
      const variant = product.variants.find((v) => {
        const o1 = v.option1?.toLowerCase() || '';
        const o2 = v.option2?.toLowerCase() || '';
        const o3 = v.option3?.toLowerCase() || '';
        return (
          o1 === lowerColor ||
          o2 === lowerColor ||
          o3 === lowerColor ||
          (v.title && v.title.toLowerCase().includes(lowerColor))
        );
      });

      if (variant) {
        // Cherche une image dans les métadonnées
        const variantMeta =
          window.collectionMetafields &&
          window.collectionMetafields.metafields &&
          window.collectionMetafields.metafields.find(
            (m) => m.id == variant.id
          );

        if (variantMeta && variantMeta.metafields) {
          let images = variantMeta.metafields;
          if (typeof images === 'string') {
            try {
              images = JSON.parse(images);
            } catch (e) {}
          }
          if (Array.isArray(images) && images.length > 0) {
            const imageUrl = gidToShopifyUrl(images[0]);
            if (imgEl && imageUrl) {
              imgEl.src = imageUrl;
              imgEl.alt = `${product.title} – ${baseColor}`;
            }
          }
        }
        matchedColor = lowerColor;
      }
    }

    let src = null;
    const matchedVariant = product.variants.find((v) => {
      const o1 = v.option1?.toLowerCase() || '';
      const o2 = v.option2?.toLowerCase() || '';
      const o3 = v.option3?.toLowerCase() || '';
      return (
        o1 === matchedColor ||
        o2 === matchedColor ||
        o3 === matchedColor ||
        (v.title && v.title.toLowerCase().includes(matchedColor))
      );
    });
    if (matchedVariant && matchedVariant.featured_image) {
      src =
        typeof matchedVariant.featured_image === 'string'
          ? matchedVariant.featured_image
          : matchedVariant.featured_image.src ||
            matchedVariant.featured_image.url;
    }
    if (!src && Array.isArray(product.images)) {
      const byId = product.images.find(
        (img) =>
          Array.isArray(img.variant_ids) &&
          img.variant_ids.includes(matchedVariant?.id)
      );
      if (byId && byId.src) src = byId.src;
    }
    if (!src && Array.isArray(product.images)) {
      const byName = product.images.find((img) => {
        const s = (img.src || '').toLowerCase();
        return s.includes(matchedColor?.toLowerCase());
      });
      if (byName && byName.src) src = byName.src;
    }
    if (!src && product.featured_image) {
      src =
        typeof product.featured_image === 'string'
          ? product.featured_image
          : product.featured_image.src || product.featured_image.url;
    } else if (
      !src &&
      Array.isArray(product.images) &&
      product.images.length > 0
    ) {
      const firstImg = product.images[0];
      src = typeof firstImg === 'string' ? firstImg : firstImg.src;
    }
    if (src) {
      imgEl.src = src;
      imgEl.alt = `${product.title} – ${matchedColor || ''}`;
      imgEl.onerror = () => {
        imgEl.onerror = null;
        injectVariantImageFallback(product, imgEl);
      };
    }
  }

  async function injectVariantImageFallback(product, imgEl) {
    if (!product || !imgEl) return;
    let src =
      product.featured_image ||
      (Array.isArray(product.images) && product.images[0]?.src) ||
      null;
    if (src) {
      imgEl.src = src;
      imgEl.alt = product.title;
    }
  }

  // --- Utils generics ---
  const Utils = {
    // Shared name mapping configuration
    getNameMapping() {
      return {
        'size-check': 'size',
        size: 'size',
        'fabric-check': 'fabric',
        fabric: 'fabric',
        'length-check': 'length',
        'silhouette-check': 'silhouette',
        'neckline-check': 'neckline',
        'occasion-check': 'occasion',
        'dress-check': 'dress_type',
        'aesthetic-check': 'aesthetic',
        'detail-check': 'details',
        'type-check': 'product_type',
        color: 'color',
        'color-check': 'color',
        sort: 'sort',
        collections: 'collections',
      };
    },

    // Transform values according to business logic (used for URL generation)
    transformParamValues(key, values) {
      let urlValue = values;

      if (key === 'dress_type') {
        urlValue = values.map((v) => {
          if (v === 'cocktail-dress') return 'cocktail';
          if (v === 'mother-of-the-bride-groom') return 'evening-mob';
          if (v === 'sleeved-dress') return 'sleeved-dress';
          return v;
        });
      }
      if (key === 'silhouette') {
        urlValue = values.map((v) => {
          if (v === 'mini-dress') return 'mini';
          return v;
        });
      }
      if (key === 'neckline') {
        urlValue = values.map((v) => {
          if (v === 'sleeved-gown') return 'sleeved-dress';
          return v;
        });
      }
      if (key === 'details') {
        urlValue = values.map((v) => {
          if (v === 'slits-in-skirt') return 'slits';
          return v;
        });
      }
      if (key === 'aesthetic') {
        urlValue = values.map((v) => {
          if (v === 'clean-minimal') return 'clean';
          return v;
        });
      }
      if (key === 'occasion') {
        urlValue = values.map((v) => {
          if (v === 'cocktail-dress') return 'cocktail';
          if (v === 'mother-of-the-bride-groom') return 'evening-mob';
          if (v === 'daytime-dress') return 'day-dress';
          return v;
        });
      }
      if (key === 'collections') {
        urlValue = values.map((v) => {
          if (v === 'nouvelle-amsale') return 'nouvelle-bridal';
          if (v === 'amsale') return 'amsale-bridal';
          if (v === 'ready-to-ship') return 'rts-bm';
          if (v === 'made-to-order') return 'mto-bm';
          return v;
        });
      }

      return urlValue;
    },

    // Reverse transformation for applying URL values to form (used for URL parameter application)
    reverseTransformParamValues(key, urlValues) {
      if (!Array.isArray(urlValues)) {
        urlValues = [urlValues];
      }

      let formValues = urlValues;

      if (key === 'dress_type') {
        formValues = urlValues.map((v) => {
          if (v === 'cocktail') return 'cocktail-dress';
          if (v === 'evening-mob') return 'mother-of-the-bride-groom';
          if (v === 'sleeved-dress') return 'sleeved-dress';
          return v;
        });
      }
      if (key === 'silhouette') {
        formValues = urlValues.map((v) => {
          if (v === 'mini') return 'mini-dress';
          return v;
        });
      }
      if (key === 'neckline') {
        formValues = urlValues.map((v) => {
          if (v === 'sleeved-dress') return 'sleeved-gown';
          return v;
        });
      }
      if (key === 'details') {
        formValues = urlValues.map((v) => {
          if (v === 'slits') return 'slits-in-skirt';
          return v;
        });
      }
      if (key === 'aesthetic') {
        formValues = urlValues.map((v) => {
          if (v === 'clean') return 'clean-minimal';
          return v;
        });
      }
      if (key === 'occasion') {
        formValues = urlValues.map((v) => {
          if (v === 'cocktail') return 'cocktail-dress';
          if (v === 'evening-mob') return 'mother-of-the-bride-groom';
          if (v === 'day-dress') return 'daytime-dress';
          return v;
        });
      }
      if (key === 'collections') {
        formValues = urlValues.map((v) => {
          if (v === 'nouvelle-bridal') return 'nouvelle-amsale';
          if (v === 'amsale-bridal') return 'amsale';
          if (v === 'rts-bm') return 'ready-to-ship';
          if (v === 'mto-bm') return 'made-to-order';
          return v;
        });
      }

      return formValues;
    },

    debounce(fn, wait = 300) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
      };
    },
    serializeAllForms() {
      const sidebarForm = UI.elements.formSideBar[0];
      const sortForm = UI.elements.formSortBy[0];

      if (!sidebarForm && !sortForm) return '';

      const combinedFormData = new FormData();

      if (sidebarForm) {
        const sidebarData = new FormData(sidebarForm);
        for (let [key, value] of sidebarData.entries()) {
          if (key !== 'current-collection' && key !== 'current-collection-id') {
            combinedFormData.append(key, value);
          }
        }

        const rangeMin = sidebarForm.querySelector('.range-min');
        const rangeMax = sidebarForm.querySelector('.range-max');
        if (rangeMin && rangeMin.value !== rangeMin.min) {
          combinedFormData.append('min_price', rangeMin.value);
        }
        if (rangeMax && rangeMax.value !== rangeMax.max) {
          combinedFormData.append('max_price', rangeMax.value);
        }
      }

      if (sortForm) {
        const sortData = new FormData(sortForm);
        for (let [key, value] of sortData.entries()) {
          if (value && value.trim() !== '') {
            combinedFormData.append(key, value);
          }
        }
      }

      const nameMapping = this.getNameMapping();
      const paramsMap = {};

      for (let [key, value] of combinedFormData.entries()) {
        if (!value || value.trim() === '') continue;
        let paramName = nameMapping[key] || key;
        if (!paramsMap[paramName]) paramsMap[paramName] = [];
        paramsMap[paramName].push(value);
      }

      const params = new URLSearchParams();
      for (const [key, values] of Object.entries(paramsMap)) {
        const transformedValues = this.transformParamValues(key, values);
        params.append(key, transformedValues.join(','));
      }

      return params.toString();
    },
    showLoading($el) {
      if ($el && $el.length) $el.css('opacity', 0.5);
    },
    hideLoading($el) {
      if ($el && $el.length) {
        $el.css('opacity', 1);
        $el.removeAttr('style');
      }
    },
    logFormData() {
      const form =
        document.getElementById('CollectionFiltersSideBar') ||
        document.getElementById('CollectionFiltersSortBy');
      if (!form) return;
      const formData = new FormData(form);
    },
  };

  function applyFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    const filterParams = [
      'color',
      'size',
      'dress_type',
      'aesthetic',
      'details',
      'in_stock',
      'occasion',
      'collections',
      'silhouette',
      'fabric',
      'length',
      'neckline',
      'product_type',
    ];

    filterParams.forEach((paramName) => {
      const paramValue = urlParams.get(paramName);
      if (paramValue) {
        const urlValues = paramValue.split(',').map((v) => v.trim().toLowerCase());

        const formValues = Utils.reverseTransformParamValues(
          paramName,
          urlValues
        );
        formValues.forEach((formValue) => {
          const formValueLower = formValue.toLowerCase();
          const selectors = [
            `input[type="checkbox"][name="${paramName}"][value="${formValue}"]`,
            `input[type="checkbox"][name="${paramName}"][value="${formValueLower}"]`,
            `input[type="checkbox"][name="filter.${paramName}"][value="${formValue}"]`,
            `input[type="checkbox"][name="filter.${paramName}"][value="${formValueLower}"]`,
            `input[type="checkbox"][data-filter="${paramName}"][value="${formValue}"]`,
            `input[type="checkbox"][data-filter="${paramName}"][value="${formValueLower}"]`,
            `input[type="checkbox"][id*="${paramName}"][value="${formValue}"]`,
            `input[type="checkbox"][id*="${paramName}"][value="${formValueLower}"]`,
            `input[type="checkbox"][data-value="${formValue}"]`,
            `input[type="checkbox"][data-value="${formValueLower}"]`,
            `input[type="checkbox"][value*="${formValue}"]`,
            `input[type="checkbox"][value*="${formValueLower}"]`,
            `input[type="checkbox"][value="${formValue}"]`,
            `input[type="checkbox"][value="${formValueLower}"]`,
            ...(paramName === 'collections'
              ? [
                  `input[type="checkbox"][name="collection"][value="${formValue}"]`,
                  `input[type="checkbox"][id*="collection"][value="${formValue}"]`,
                  `input[type="checkbox"][data-collection="${formValue}"]`,
                  `input[type="checkbox"][data-type="collections"][value="${formValue}"]`,
                ]
              : []),
          ];

          let found = false;
          for (const selector of selectors) {
            const checkbox = UI.elements.formSideBar.find(selector);
            if (checkbox.length) {
              checkbox.prop('checked', true);
              found = true;
              // Store color in localStorage when applied from URL
              if (paramName === 'color') {
                localStorage.setItem('lastClickedColor', formValueLower);
                localStorage.setItem('lastClickedColorCollection', window.location.pathname);
              }
              break;
            }
          }
        });
      }
    });

    const sortParam = urlParams.get('sort');
    if (sortParam) {
      const sortSelectors = [
        `select[name="sort"]`,
        `select[name="sort_by"]`,
        `input[name="sort"]`,
        `input[name="sort_by"]`,
        `select[id="SortBy"]`,
        `#SortBy`,
      ];

      let sortApplied = false;
      for (const selector of sortSelectors) {
        const sortElement = UI.elements.formSortBy.find(selector);
        if (sortElement.length) {
          sortElement.val(sortParam);
          sortApplied = true;
          break;
        }
      }
    }

    const priceMin = urlParams.get('price_min');
    const priceMax = urlParams.get('price_max');
    if (priceMin) {
      const minElement = UI.elements.formSideBar.find('.range-min');
      if (minElement.length) {
        minElement.val(priceMin);
      }
    }
    if (priceMax) {
      const maxElement = UI.elements.formSideBar.find('.range-max');
      if (maxElement.length) {
        maxElement.val(priceMax);
      }
    }

    urlParams.forEach((value, key) => {
      if (
        key.startsWith('filter.') &&
        !filterParams.includes(key.replace('filter.', ''))
      ) {
        const filterName = key.replace('filter.', '');
        const values = value.split(',');
        values.forEach((val) => {
          const valTrimmed = val.trim();
          const valLower = valTrimmed.toLowerCase();
          const checkbox = UI.elements.formSideBar.find(
            `input[type="checkbox"][name="${key}"][value="${valTrimmed}"], input[type="checkbox"][name="${key}"][value="${valLower}"], input[type="checkbox"][name="${filterName}"][value="${valTrimmed}"], input[type="checkbox"][name="${filterName}"][value="${valLower}"]`
          );
          if (checkbox.length) {
            checkbox.prop('checked', true);
          }
        });
      }
    });

    urlParams.forEach((value, key) => {
      if (
        !filterParams.includes(key) &&
        !key.startsWith('filter.') &&
        key !== 'sort' &&
        key !== 'price_min' &&
        key !== 'price_max'
      ) {
        const values = value.split(',');
        values.forEach((val) => {
          const valTrimmed = val.trim();
          const valLower = valTrimmed.toLowerCase();
          const checkbox = UI.elements.formSideBar.find(
            `input[type="checkbox"][name="${key}"][value="${valTrimmed}"], input[type="checkbox"][name="${key}"][value="${valLower}"]`
          );
          if (checkbox.length) {
            checkbox.prop('checked', true);
          }
        });
      }
    });
    updateCollapsibleSections();
  }

  function updateCollapsibleSections() {
    UI.elements.formSideBar.find('.item-collapsible').each(function () {
      const $section = $(this);
      const $content = $section.find('.item-collapsible-content');
      const $button = $section.find('.collapsible-label');

      const $checkedInputs = $content.find('input[type="checkbox"]:checked');
      const $rangeInputs = $content
        .find('input.range-min, input.range-max')
        .filter(function () {
          return this.value !== this.min && this.value !== this.max;
        });

      const hasActiveFilters =
        $checkedInputs.length > 0 || $rangeInputs.length > 0;

      if (hasActiveFilters) {
        $content.addClass('active');
        $button.attr('aria-expanded', 'true');
      }
    });
  }

  // --- Main ---
  const App = {
    init() {
      // Clear stored color filter when the collection changes
      var storedColor = localStorage.getItem('lastClickedColor');
      var storedColorCollection = localStorage.getItem('lastClickedColorCollection');
      var currentCollection = window.location.pathname;
      if (storedColor && storedColorCollection !== currentCollection) {
        localStorage.removeItem('lastClickedColor');
        localStorage.removeItem('lastClickedColorCollection');
      }

      loadColorDictionary().then(() => {
        UI.initialize();
        if (!UI.elements.formSideBar.length) {
          console.error('Formulaire sidebar de filtrage non trouvé');
          return;
        }

        if (!UI.elements.formSortBy.length) {
          console.warn('Formulaire de tri non trouvé - tri désactivé');
        }

        this.bindEvents();

        applyFiltersFromURL();

        // Re-apply stored color filter if same collection but no URL color param
        var urlParams = new URLSearchParams(window.location.search);
        var storedColor = localStorage.getItem('lastClickedColor');
        if (storedColor && !urlParams.get('color')) {
          var colorCheckbox = UI.elements.formSideBar.find(
            'input[type="checkbox"][name="color"]'
          ).filter(function () {
            return $(this).val().toLowerCase() === storedColor;
          });
          if (colorCheckbox.length && !colorCheckbox.prop('checked')) {
            colorCheckbox.prop('checked', true);
            // Update URL to include the color param
            urlParams.set('color', storedColor);
            history.replaceState(null, '', window.location.pathname + '?' + urlParams.toString());
          }
        }

        UI.initChips();
        if (urlParams.toString() !== '') {
          this.fetchAndRender();
        }
        updateCollapsibleSections();
      });
    },

    bindEvents() {
      UI.elements.formSideBar.on(
        'change',
        'input[type="checkbox"].checkb-filter',
        Utils.debounce((e) => {
          const target = e.target;
          if (target.name === 'color') return;
          if (!target.id.startsWith('chk_')) {
            this.fetchAndRender();
            setTimeout(() => updateCollapsibleSections(), 100);
          }
        }, 300)
      );

      UI.elements.formSideBar.on(
        'change',
        'input[type="checkbox"].checkb-filter[name="color"]',
        Utils.debounce((e) => {
          const target = e.target;
          if (target.checked) {
            localStorage.setItem(
              'lastClickedColor',
              target.value.toLowerCase()
            );
            localStorage.setItem(
              'lastClickedColorCollection',
              window.location.pathname
            );
          } else {
            localStorage.removeItem('lastClickedColor');
            localStorage.removeItem('lastClickedColorCollection');
          }
          if (!target.id.startsWith('chk_')) {
            this.fetchAndRender();
            setTimeout(() => updateCollapsibleSections(), 100);
          }
        }, 300)
      );

      UI.elements.formSortBy.on(
        'change',
        'select[name="sort"]',
        Utils.debounce((e) => {
          e.preventDefault();
          e.stopPropagation();
          this.fetchAndRender();
        }, 300)
      );
      const updateMinDisplay = (val) =>
        UI.elements.formSideBar.find('.lowest-range').text(`$${val}`);
      const updateMaxDisplay = (val) =>
        UI.elements.formSideBar.find('.highest-range').text(`$${val}`);
      UI.elements.formSideBar.on(
        'input',
        'input.range-min',
        Utils.debounce((e) => {
          const val = e.target.value;
          updateMinDisplay(val);
          App.fetchAndRender();
          setTimeout(() => updateCollapsibleSections(), 100);
        }, 200)
      );

      UI.elements.formSideBar.on(
        'input',
        'input.range-max',
        Utils.debounce((e) => {
          const val = e.target.value;
          updateMaxDisplay(val);
          App.fetchAndRender();
          setTimeout(() => updateCollapsibleSections(), 100);
        }, 200)
      );
      UI.elements.formSideBar.on('submit', (e) => {
        e.preventDefault();
        this.fetchAndRender();
        this.closeDrawer();
      });
      $(document).on('click', 'button.apply-filters-btn', (e) => {
        e.preventDefault();
        Utils.logFormData();
        this.fetchAndRender();
        this.closeDrawer();
      });
      $(document).on('click', '.remove-filter-btn', function (e) {
        e.preventDefault();
        const { type, value } = this.dataset;

        if (type === 'price') {
          UI.elements.formSideBar
            .find('.range-min')
            .val(function () {
              return this.min;
            })
            .end()
            .find('.range-max')
            .val(function () {
              return this.max;
            })
            .end()
            .find('.range-min, .range-max')
            .trigger('input');
        } else if (type === 'sort') {
          UI.elements.formSortBy.find('select[name="sort"]').val('');
        } else {
          // Récupère le texte du chip (le parent du bouton)
          const chipText = $(this).parent('.filter-chip').text().trim();

          // Transforme le texte en format "handleize" (minuscules avec tirets)
          const handleizedText = chipText
            .toLowerCase()
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');

          // Cherche la checkbox par sa valeur "handleized"
          const $checkbox = UI.elements.formSideBar.find(
            `input[type="checkbox"][value="${handleizedText}"], 
       input[type="checkbox"][value="${value}"]`
          );

          // Cherche l'input caché par sa valeur
          const $hidden = UI.elements.formSideBar.find(
            `input[type="hidden"][value="${handleizedText}"], 
       input[type="hidden"][value="${value}"]`
          );

          if ($checkbox.length) {
            $checkbox.prop('checked', false);
          } else if ($hidden.length) {
            $hidden.remove();
          }

          // Clear stored color when removing a color filter chip
          if (type === 'color') {
            localStorage.removeItem('lastClickedColor');
            localStorage.removeItem('lastClickedColorCollection');
          }
        }

        // re-run the filter
        App.fetchAndRender();
        // Update collapsible sections after removing filter
        setTimeout(() => updateCollapsibleSections(), 100);
      });

      $(document).on('click', '.clear-filters', (e) => {
        e.preventDefault();
        UI.elements.formSideBar[0].reset();
        UI.elements.formSortBy[0].reset();

        const rangeMin = UI.elements.formSideBar.find('.range-min')[0];
        const rangeMax = UI.elements.formSideBar.find('.range-max')[0];
        if (rangeMin) rangeMin.value = rangeMin.min;
        if (rangeMax) rangeMax.value = rangeMax.max;
        history.replaceState(null, '', window.location.pathname);
        localStorage.removeItem('lastClickedColor');
        localStorage.removeItem('lastClickedColorCollection');
        localStorage.removeItem('lastSelectedColor');
        App.fetchAndRender();
        setTimeout(() => updateCollapsibleSections(), 100);
      });
      $(document).on('click', 'button.open-refine-section', () =>
        this.openDrawer('.filter-refine-section')
      );
      $(document).on('click', 'button.open-filters-section', () =>
        this.openDrawer('.filter-section')
      );
      $(document).on('click', 'button#close-drawer-btn', () =>
        this.closeDrawer()
      );
    },

    openDrawer(selector) {
      $('#shopify-section-header').addClass('hide-header');
      $(selector).addClass('show-section');
      $('.grid__item--sidebar').addClass('open-drawer');
      $('html, body').addClass('sidebar-open');
      $('#zsiq_float').hide();
    },

    closeDrawer() {
      $('#shopify-section-header').removeClass('hide-header');
      $('.filter-refine-section, .filter-section').removeClass('show-section');
      $('.grid__item--sidebar').removeClass('open-drawer');
      $('html, body').removeClass('sidebar-open');
      $('#zsiq_float').css('display', 'inline-block');
    },

    async fetchAndRender() {
      if (
        !UI.elements.formSideBar.length ||
        !UI.elements.formSortBy.length ||
        !UI.elements.grid.length
      ) {
        console.error('Éléments manquants pour le filtrage');
        return;
      }
      const collectionId = $('input[name="current-collection-id"]').val();
      if (!collectionId) {
        console.error('ID de collection manquant');
        return;
      }
      const query = Utils.serializeAllForms();
      const apiUrl = `https://api.ecom.amsale.com/api/inventory/${collectionId}/products?${query}`;
      const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', '_kx'];
      const trackingParams = trackingKeys
        .filter((k) => initialUrlParams.has(k))
        .map((k) => `${k}=${encodeURIComponent(initialUrlParams.get(k))}`)
        .join('&');
      const pageUrl = `${window.location.pathname}?${query}${trackingParams ? '&' + trackingParams : ''}`;
      Utils.showLoading(UI.elements.grid);
      console.log('Fetching products with URL:', apiUrl);
      try {
        if (!color_dictionary || Object.keys(color_dictionary).length === 0) {
          await loadColorDictionary();
        }
        const response = await fetch(apiUrl, {
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Erreur API ${response.status}`);
        const data = await response.json();
        if (!data.products || !Array.isArray(data.products)) {
          console.error('Format de réponse API invalide', data);
          return;
        }

        // GraphQL query removed from inline placement to avoid JS syntax errors.
        // Use PRODUCT_WITH_COMPARE_AT_PRICE_QUERY constant (defined above)
        // when invoking GraphQL via the appropriate endpoint.
        UI.renderProducts(
          data.products,
          data.total_count || data.products.length
        );
        history.replaceState(null, '', pageUrl);
        UI.initChips();
        setTimeout(() => UI.loadVariantImages(data.products), 0);

        // Si tout va bien, réactive les filtres au cas où ils étaient désactivés
        UI.elements.formSideBar
          .find('input, select, button')
          .prop('disabled', false);
        UI.elements.formSortBy
          .find('input, select, button')
          .prop('disabled', false);
        $('#filter-error-notice').remove();
      } catch (err) {
        console.error('Filtrage API échoué :', err);

        // Désactive tous les filtres
        UI.elements.formSideBar
          .find('input, select, button')
          .prop('disabled', true);
        UI.elements.formSortBy
          .find('input, select, button')
          .prop('disabled', true);

        // Affiche un message d'erreur si pas déjà présent
        if (!$('#filter-error-notice').length) {
          UI.elements.grid.before(`
        <div id="filter-error-notice" style="color: #b00; background: #fff3f3; padding: 1em; margin-bottom: 1em; border: 1px solid #b00;">
  Filters are temporarily disabled because the search service is unavailable. Please try again later.
</div>
      `);
        }
      } finally {
        Utils.hideLoading(UI.elements.grid);
      }
    },
  };

  $(function () {
    setTimeout(() => App.init(), 100);
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collapsible-label').forEach(function (btn) {
    // Supprime les écouteurs existants pour éviter les doublons
    btn.removeEventListener('click', toggleCollapsible);
    // Ajoute le nouvel écouteur
    btn.addEventListener('click', toggleCollapsible);
  });

  function toggleCollapsible() {
    const content = document.getElementById(this.getAttribute('aria-controls'));
    if (!content) return;

    const expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !expanded);
    content.setAttribute('aria-hidden', expanded);
    content.classList.toggle('active', !expanded);
  }
});
